import React from 'react';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import useStyle from './pedagogicalChallengeSingle.style';
import { IconLabel } from 'components/atoms/Texts/IconLabel';
import { ContainerHalf } from 'components/layouts/ContainerHalf';
import emojis from 'theme/emoji';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { ChallengeRules } from './ChallengeRules';
import { Defi } from 'graphql/generated/graphql';
import { WinnersList } from './WinnersList';
import { formatDate, getDaysAndHoursLeft } from 'helpers/date/formatDate';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { LinksList } from './LinksList';

interface PedagogicalChallengeSingleViewProps {
  goBack: () => void;
  defiData: Defi;
}

export const PedagogicalChallengeSingleView = ({
  goBack,
  defiData
}: PedagogicalChallengeSingleViewProps) => {
  const classes = useStyle();
  const recompensesTab = defiData.recompenses;

  return (
    <div className={classes.root}>
      <ContainerFullWidth>
        <div className={classes.header}>
          <div className={classes.headerTop}>
            <p>
              Défi{' '}
              <span role="img" aria-label="Journal">
                🗞️
              </span>
            </p>
            <IconButton icon="Close" variant="flat" onClick={goBack} />
          </div>
          <div className={classes.headerBottom}>
            <h1>{defiData.name}</h1>
            <div>
              <IconLabel
                withoutMargin={true}
                icon="Clock"
                label={defiData.fin && getDaysAndHoursLeft(defiData.fin)}
              />
              <IconLabel
                withoutMargin={true}
                icon="Calendar"
                label={`Du ${defiData.debut &&
                  formatDate(defiData.debut)} au ${defiData.fin &&
                  formatDate(defiData.fin)}`}
              />
            </div>
          </div>
        </div>
        <div className={classes.content}>
          <ContainerHalf
            col1={
              <div className={classes.colContainer}>
                {defiData.reglement.length > 0 && (
                  <div>
                    <HeaderText
                      text="Règlement du défi"
                      emoji={emojis['Ruler']}
                    />
                    <ChallengeRules rules={defiData.reglement} />
                  </div>
                )}
                {defiData.ressources && defiData.ressources.length > 0 && (
                  <div>
                    <HeaderText
                      text="Liens ressources"
                      emoji={emojis['Link']}
                    />
                    <LinksList ressources={defiData.ressources} />
                  </div>
                )}
              </div>
            }
            col2={
              <div className={classes.colContainer}>
                {recompensesTab.length > 0 && (
                  <div>
                    <HeaderText text="Lots à gagner" emoji={emojis['Gift']} />
                    <FeatureContainer padding="small">
                      {recompensesTab.map((recompense, index) => (
                        <div className={classes.lotsContainer} key={index}>
                          <p>{recompense.category}</p>
                          <p>{recompense.lots}</p>
                        </div>
                      ))}
                    </FeatureContainer>
                  </div>
                )}
                <div>
                  <HeaderText text="Résultats" emoji={emojis['Fire']} />
                  <FeatureContainer padding="small">
                    <WinnersList list={recompensesTab} />
                  </FeatureContainer>
                </div>
              </div>
            }
          />
        </div>
      </ContainerFullWidth>
    </div>
  );
};
